export class FieldChangeResult {
    private _type: FieldChangeResultType = FieldChangeResultType.Unknown;
    private _data: string = "";
    constructor(type: FieldChangeResultType, data: string) {
        this._type = type;
        this._data = data;
    }

    get Type(): FieldChangeResultType {
        return this._type;
    }

    set Type(value: FieldChangeResultType) {
        this._type = value;
    }

    get Data(): string {
        return this._data;
    }

    set Data(value: string) {
        this._data = value;
    }
}

export class ResponseResult<T> {
    private _type: T | null = null;
    private _data: string = "";

    constructor(type: T, data: string) {
        this._type = type;
        this._data = data;
    }

    get Type(): T {
        return this._type as T;
    }

    set Type(value: T) {
        this._type = value;
    }

    get Data(): string {
        return this._data;
    }

    set Data(value: string) {
        this._data = value;
    }
}

export enum FieldChangeResultType {
    ResourceDoesNotExists = -6,
    UnknownError = -5,
    NoPermissions = -4,
    WrongData = -3,
    ControllerResponseTimeout = -2,
    Failed = -1,
    Unknown = 0,
    Changed = 1,
}